import React, { Component } from "react";
import { Container, Form, Button, Nav, NavItem, NavLink } from "reactstrap";
import "./randomtest.css";
import { library, counter } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sample } from "lodash";
import { faClock } from "@fortawesome/free-solid-svg-icons";
library.add(faClock);

class Randomtest18 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 20
    };
  }

  render() {
    const { count } = this.state;
    return (
      <div>
        <Container className="comming">
          <Form className="boxrandomtest">
            <h1 className="textrandomtest">แบบทดสอบวัดระดับ</h1>
            <h1 className="cdtimer">
              <FontAwesomeIcon icon="clock" /> {count}
            </h1>
            <Form className="Q1">
              <h3 className="textStudy2">
                5.
                เหตุผลสำคัญที่ทำให้รัฐโบราณมักตั้งราชธานีอยู่ริมแม่น้ำหรือชายฝั่งทะเลคืออะไร
              </h3>{" "}
              <br></br>
              <Button className="rdTest1" href="/conclude17_1">
                <h5>ก. ใช้แหล่งน้ำเป็นปราการธรรมชาติป้องกันศัตรู</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude17_1">
                <h5>ข. พื้นที่เป็นดินอ่อนนุ่มสร้างบ้านเรือนได้ง่าย</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude18_2">
                <h5>ค. สะดวกแก่การเพาะปลูกและติดต่อค้าขาย</h5>
              </Button>
            </Form>

            <Button className="rdTestbt1" href="/conclude17_1">
              <h5>ข้ามข้อนี้</h5>
            </Button>
            <br></br>
            <h3 className="ranknumberB">1</h3>
            <h3 className="ranknumberB1">2</h3>
            <h3 className="ranknumberB1">3</h3>
            <h3 className="ranknumberB1">4</h3>
            <h3 className="ranknumberW1">5</h3>
          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { startCount } = this.props;
    this.setState({
      count: startCount
    });
    this.doIntervalChange();
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState(prevState => {
        const newCount = prevState.count - 1;
        if (newCount == -1) {
          clearInterval(this.myInterval);
          this.props.history.push("/conclude17_1");
        }
        return { count: newCount };
      });
    }, 1000);
  }

  componentWillMount() {
    clearInterval(this.myInterval);
  }
}

export default Randomtest18;
